<!-- Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/ -->

<!-- prettier-ignore -->
<ng-template #innerTemplate>
  <!-- TODO CC-8420: remove class after -->
  @if (svgIcon) {<mat-icon [class]="level" class="svg-icon" [svgIcon]="svgIcon"></mat-icon>}
  @if (icon) {<mat-icon [class]="level">{{ icon }}</mat-icon>}
  <span gta="status_output_text"><ng-content></ng-content></span>
</ng-template>
